<nav id="sidebar" class="sidebar-wrapper">
  <div class="sidebar-content">
    <div class="sidebar-brand">
      <a [routerLink]="'/home'">
        <img [src]="'assets/images/logoQuality.png'" height="24" class="block h-[70px] mx-auto" alt="">
      </a>
      <p class="text-xl font-bold text-center mt-1">QualitySync</p>
    </div>
    <ngx-simplebar #sidebar class="h-[calc(100vh-70px)]">
      <ul class="sidebar-menu border-t dark:border-white/10 border-gray-100">
        @for (item of currentMenuItems(); track item.name)
        {
          @if (!item.subMenu)
          {
            <li [ngClass]="item.link === menu() ? 'active' : ''">
              <a [routerLink]="item.link">
                <i [attr.data-feather]="item.icon" class="h-4 w-4 me-3"></i>
                {{ item.name }}
              </a>
            </li>
          } @else {
            <li class="sidebar-dropdown" [ngClass]="getMenuItemNames(item).includes(subMenu() || menu()) ? 'active' : ''">
              <a href="#" (click)="openMenu($event, item.subMenu[0].link)">
                <i [attr.data-feather]="item.icon" class="h-4 w-4 me-3"></i>
                {{ item.name }}
              </a>
              <div class="sidebar-submenu" [ngClass]="getMenuItemNames(item).includes(subMenu() || menu()) ? 'block' : ''">
                <ul>
                  @for (subItem of item.subMenu; track subItem.name)
                  {
                    <li [ngClass]="menu() === subItem.name ? 'active' : ''">
                      <a [routerLink]="subItem.link">{{ subItem.name }}</a>
                    </li>
                  }
                </ul>
              </div>
            </li>
          }
        }

      </ul>
      <!-- sidebar-menu  -->
    </ngx-simplebar>
  </div>
</nav>
